import { useState } from 'react';
import WorkQueTypeSelect from '../../../components/WorkQueTypeSelect/WorkQueTypeSelect';
import Section from '../../../components/NewApplication/Section';
import Input from '@mui/material/Input';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import styles from '../../../ApplicationMaintenance.module.scss';
import { Button } from '@upmc/ims.component-library';
import MaterialIcon from '@material/react-material-icon';
import NewAppRequest from '../../../../../Classes/ResponseModels/ApplicationManagement/NewAppRequest';
import { AddNewWQSystem, GetWQSystems } from '../../../_api';
import ApiErrors from '../../../components/NewApplication/ApiErrors';
import Spinner from '../../../../../components/UI/Spinner/Spinner';
const WQSystemForm = ({
	appID,
	app,
	currentUser,
	requirementNumber,
	readOnly,
	setModalOpen,
	setAppSystems,
}) => {
	const [workQueType, setWorkQueType] = useState(null);
	const [systemID, setSystemID] = useState(null);
	const [systemName, setSystemName] = useState(app?.appMaster?.name ?? null);
	const [order, setOrder] = useState(null);
	const [isLoading, setIsLoading] = useState();
	const [apiErrors, setApiErrors] = useState([]);

	const handleSave = () => {
		let request = new NewAppRequest(app, currentUser);
		request.RequirementNumber = requirementNumber;
		request.appSystemOrder = order;
		request.systemID = systemID;
		request.systemName = systemName;
		request.workQueType = workQueType;

		setIsLoading(true);
		AddNewWQSystem(request)
			.then(response => {
				if (response.Errors) {
					setApiErrors(response.Errors);
				}
			})
			.then(x => {
				if (apiErrors.length === 0) {
					GetWQSystems(appID).then(response => {
						setAppSystems(response);
					});
					setModalOpen(false);
					setIsLoading(false);
				}
			});
	};

	return (
		<div>
			<ApiErrors errors={apiErrors} />
			<Section label={'Work Queue'}>
				{isLoading ? (
					<Spinner />
				) : (
					<>
						<WorkQueTypeSelect
							workQueType={workQueType}
							setWorkQueType={setWorkQueType}
							systemID={systemID}
							setSystemID={setSystemID}
							systemName={systemName}
							setSystemName={setSystemName}
						/>
						<br />
						<FormControl variant='standard'>
							<InputLabel htmlFor='order_input'>Order</InputLabel>
							<Input
								id='order_input'
								value={order}
								onChange={e => setOrder(e.target.value)}
								type='number'
							/>
						</FormControl>
					</>
				)}
			</Section>
			<div className={styles.controlsContainer}>
				<Button
					onClick={e => {
						handleSave();
					}}
					startIcon={<MaterialIcon icon='save' />}
					disabled={readOnly}
				>
					Save
				</Button>
			</div>
		</div>
	);
};

export default WQSystemForm;
